<template>
  <Popover
    ref="op"
    :pt="{
      root: {
        class: [
          // Shape
          'border',

          // Color and Background
          'border-charcoal-200 dark:border-charcoal-800',
          'bg-white dark:bg-charcoal-900',

          // Font
          'text-sm'
        ]
      },
      content: {
        class: [
          // Size
          'h-full',

          // Overflow
          'overflow-y-auto'
        ]
      }
    }"
  >
    <slot />
  </Popover>
</template>

<script setup>
import { ref } from 'vue'
import Popover from 'primevue/popover'

// Creating a reference object to be used for the PrimeVue Popover
const op = ref()

// Exposing the references 'toggle'/'hide' functions in our own functions so parent elements can control the popover
defineExpose({
  toggle: (event) => op.value.toggle(event),
  hide: () => op.value.hide()
})
</script>

<style lang="css">
.p-popover::before,
.p-popover::after {
    display: none; /* Hide the caret */
}
</style>
